import { isStringEmpty } from "@/common/validation-checkers";

interface IProps {
    value?: boolean;
    purpose: string;
    newValue: (val: boolean | undefined) => void;
    alternativeYes?: string;
    alternativeNo?: string;
}

const YesAndNoDropdownComponent: React.FC<IProps> = ({value, purpose, newValue, alternativeYes, alternativeNo}) => {

    const yes = alternativeYes ?? "Yes";
    const no = alternativeNo ?? "No";

    let parsedValue;
    
    switch (value) {
        case null:
        case undefined:
            parsedValue = undefined;
            break;

        case false:
            parsedValue = "0";
            break;

        case true:
            parsedValue = "1";
            break;
    }

    function handleChange(value: string){
        if (isStringEmpty(value)) {
            newValue(undefined)
        } else if (value === "1") {
            newValue(true)
        } else {
            newValue(false)
        }
    }

    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            <select 
                id={purpose}
                className="text-black px-2 py-1 block w-full h-8"
                value={parsedValue} 
                onChange={(event) => handleChange(event.target.value)}
            >
                {value === undefined && (
                    <option value={""}>
                        Please select an option
                    </option>
                )}

                <option value={"1"}>
                    {yes}
                </option>

                <option value={"0"}>
                    {no}
                </option>
            </select>
        </div>
    )
}

export default YesAndNoDropdownComponent;